import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { Grid, Paper, Button } from '@material-ui/core';
import { CircularProgress, Typography, Divider } from '@material-ui/core';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';

import TextField from 'components/Form/TextField';
import TagList from './TagList/TagList';
import text from 'texts/translations';
import { Link } from 'react-router-dom';

import styles from '../App.css';
import componentStyles from './CreateUser.css';
import { withSnackbar } from 'notistack';
import UserPriviligesSelect from '../../components/UserPrivilegesSelect/UserPriviligesSelect';
import Translation from '../../components/Translation/Translation';

//create new user account
@inject('formDataStore')
@observer
class CreateUser extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user: {
        username: '',
        password: '',
        firstName: '',
        lastName: '',
        email: '',
        company: '',
        jobTitle: '',
        templateRightsLevel: ''
      }
    };

    this.updateProperty = this.updateProperty.bind(this);
  }

  updateProperty(key, value) {
    var user = this.state.user;
    user[key] = value;

    this.setState({user});
  }

  create() {
    this.props.customerCaseStore.userRegister(this.state.user)
      .then((data) => {
        if (data.errors || data.error) {
          throw data;
        }

        this.props.enqueueSnackbar(<Translation>action.create_success</Translation>, {variant: 'success'})
        this.props.history.push('/users');
      })
      .catch(() => this.props.enqueueSnackbar(<Translation>action.create_failed</Translation>, {variant: 'error'}));
  }

  renderData() {
    return (
      <Grid item xs={12}>
        <Grid item xs={12}>
          <TextField
            id="username"
            helperText={<Translation>username</Translation>}
            value={this.state.user.username}
            onChange={event => {
              this.updateProperty('username', event.target.value);
            }}
            style={componentStyles.textField}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            id="password"
            type="password"
            helperText={<Translation>password</Translation>}
            value={this.state.user.password}
            onChange={event => {
              this.updateProperty('password', event.target.value);
            }}
            style={componentStyles.textField}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            id="firstname"
            helperText={<Translation>firstName</Translation>}
            value={this.state.user.firstName}
            onChange={event => {
              this.updateProperty('firstName', event.target.value);
            }}
            style={componentStyles.textField}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            id="lastname"
            helperText={<Translation>lastName</Translation>}
            value={this.state.user.lastName}
            onChange={event => {
              this.updateProperty('lastName', event.target.value);
            }}
            style={componentStyles.textField}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            id="email"
            helperText={<Translation>email</Translation>}
            type="email"
            value={this.state.user.email}
            onChange={event => {
              this.updateProperty('email', event.target.value);
            }}
            style={componentStyles.textField}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            id="company"
            helperText={<Translation>company</Translation>}
            value={this.state.user.company}
            onChange={event => {
              this.updateProperty('company', event.target.value);
            }}
            style={componentStyles.textField}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            id="jobtitle"
            helperText={<Translation>jobTitle</Translation>}
            value={this.state.user.jobTitle}
            onChange={event => {
              this.updateProperty('jobTitle', event.target.value);
            }}
            style={componentStyles.textField}
          />
        </Grid>

        <Grid item xs={12} style={styles.marginBottom}>
          <UserPriviligesSelect
            helperText={<Translation>templateRightsLevel</Translation>}
            value={this.state.user.templateRightsLevel}
            onChange={(event) => this.updateProperty('templateRightsLevel', event.target.value)}
            style={componentStyles.textField}
            />
        </Grid>

        <Button
          variant="raised"
          color="primary"
          onClick={this.create.bind(this)}>
          {<Translation>register</Translation>}
        </Button>
      </Grid>
    );
  }

  render() {
    return (
      <Grid item xs={12}>
        <Paper style={styles.paper}>{this.renderData()}</Paper>
      </Grid>
    );
  }
}

export default withSnackbar(CreateUser);



// WEBPACK FOOTER //
// ./src/views/CreateUser/CreateUser.jsx